import { FormikProps } from "formik";
import { useFGContext } from "nsitools-react";
import * as React from "react";

export interface IFGFormikChangesProps<T> {
  onFormikChange: (ctx: FormikProps<T>) => void;
}

export function FGFormikChanges<T>({
  onFormikChange,
}: IFGFormikChangesProps<T>) {
  const { formik } = useFGContext();

  React.useEffect(() => {
    if (formik && onFormikChange) {
      onFormikChange(formik);
    }
  }, [formik, onFormikChange]);

  return <></>;
}
